<template>
  <div v-if="!hidden">
    <QuestionLabel
      :number="question.questionNumber"
      :text="question.text"
    ></QuestionLabel>
    <div class="pb-6">
      <div v-if="dense" class="mb-16" key="dense">
        <div class="mt-3 mb-8">
          <table class="w-100">
            <thead>
              <th class="pl-0 pb-4"></th>
              <th
                v-for="option in question.options"
                :key="option.value"
                class="vertical-align-bottom text-right text-capitalize"
                style="width: 100px"
              >
                {{ option.text }}
              </th>
            </thead>
            <tr v-for="child in question.children" :key="child.key">
              <td class="w-100 py-4 d-flex">
                <v-chip
                  v-if="child.questionNumber && child.questionNumber.length > 0"
                  color="secondary"
                  class="text-capitalize mr-4 flex-shrink-0"
                >
                  {{ child.questionNumber }}
                </v-chip>
                <div class="d-flex align-center">
                  <survey-question-text
                    :text="child.text"
                  ></survey-question-text>
                </div>
              </td>
              <td
                class="text-right text-no-wrap"
                v-for="option in question.options"
                :key="option.value"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      {{ getRate(child.key, option) | percentage }}
                    </div>
                  </template>
                  <span>{{ option.text }}</span>
                </v-tooltip>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <template v-else>
        <div v-for="child in question.children" :key="child.key" class="mb-16">
          <div class="mt-3 mb-8">
            <div
              class="font-weight-bold d-flex text-left mb-4"
              v-if="smallScreen"
            >
              <v-chip
                v-if="child.questionNumber && child.questionNumber.length > 0"
                color="secondary"
                class="text-capitalize mr-2 flex-shrink-0"
                >{{ child.questionNumber }}</v-chip
              >
              <survey-question-text
                :text="child.text"
                class="mt-1"
              ></survey-question-text>
            </div>
            <table>
              <thead>
                <th class="pl-0 pb-4">
                  <div
                    class="font-weight-bold d-flex text-left"
                    v-if="!smallScreen"
                  >
                    <v-chip
                      v-if="
                        child.questionNumber && child.questionNumber.length > 0
                      "
                      color="secondary"
                      class="text-capitalize mr-2 flex-shrink-0"
                      >{{ child.questionNumber }}</v-chip
                    >
                    <survey-question-text
                      :text="child.text"
                      class="mt-1"
                    ></survey-question-text>
                  </div>
                </th>
                <th class="vertical-align-bottom text-right text-capitalize">
                  Percentage
                </th>
              </thead>
              <tr v-for="option in question.options" :key="option.value">
                <td class="w-100 pl-10">{{ option.text }}</td>
                <td class="text-right text-no-wrap">
                  {{ getRate(child.key, option) | percentage }}
                </td>
              </tr>
              <!-- <tr>
              <td class="grey darken-2 py-0" v-for="i in 2" :key="i"></td>
            </tr>
            <tr>
              <td class="grey darken-2 py-0" v-for="i in 2" :key="i"></td>
            </tr>
            <tr>
              <td class="font-weight-bold pl-10">Response Rate</td>
              <td class="text-right pl-12 font-weight-bold text-no-wrap">0</td>
            </tr> -->
            </table>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
$blueFill: rgba(101, 146, 230, 0.15);
$greyFill: rgba(0, 0, 0, 0.05);

table {
  border-collapse: collapse; /* Remove cell spacing */

  thead {
    th {
      vertical-align: bottom;
      text-align: center;
      padding-top: 0.5rem;
      border-radius: 0.5rem 0.5rem 0 0;
      padding: 0.5rem 1rem 0.25rem 1rem;

      &:nth-child(even) {
        background: $greyFill;
      }
    }
  }

  th,
  td {
    padding: 0.25rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    text-align: left;
  }

  tr,
  tfoot {
    &:nth-child(odd) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
    &:nth-child(even) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
  }

  tr {
    &:hover {
      background: rgba(0, 0, 0, 0.15) !important;

      td {
        border-color: rgba(0, 0, 0, 0.25);
      }
    }

    &:nth-child(even) {
      background: $blueFill;
    }
  }

  tfoot {
    td {
      border-radius: 0 0 0.5rem 0.5rem;
      padding: 0.5rem;
    }
  }
}
</style>

<script>
import numeral from "numeral";

import QuestionLabel from "./QuestionReport.Label.vue";
import SurveyQuestionText from "./Survey.Question.Text.vue";

export default {
  components: { QuestionLabel, SurveyQuestionText },
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    },
  },
  data: () => ({}),
  props: {
    survey: Object,
    question: Object,
    agg: Object,
    dense: Boolean,
  },
  computed: {
    smallScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hidden() {
      return this.settings.private === "true";
    },
    settings() {
      var result = {};

      this.question.settings.forEach((x) => {
        result[x.key] = x.value;
      });

      return result;
    },
  },
  methods: {
    questionData(questionKey) {
      var results = this.agg.results.filter((x) => x.key === questionKey);
      if (results.length == 0) return null;
      else return results[0];
    },
    getRate(questionKey, option) {
      let data = this.questionData(questionKey);
      if (!data) return 0;

      var numerator =
        data.counts.find((x) => x.key === option.value)?.value ?? 0;

      var denominator = 0;

      if (option.responseCountTarget) {
        denominator = option.responseCountTarget;
      } else if (this.question.responseCountTarget) {
        denominator = this.question.responseCountTarget;
      } else if (this.survey.responseCountTarget) {
        denominator = this.survey.responseCountTarget;
      } else if (data.responses) {
        denominator = data.responses;
      } else {
        denominator = this.agg.responseCount;
      }

      if (!numerator) return 0;
      else return numerator / denominator;
    },
  },
};
</script>
